﻿<template>

    <div class="lg-head">
        <span class="lg-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
        </span>
        <h2 class="lg-heading">Agent login</h2>
        <p class="lg-intro">Please login with your agency email address</p>
    </div>

    <login_alert :message="error_message" title="Login failed" @dismiss="error_message = ''"></login_alert>

    <div class="lg-form">
        <div class="mb-field">
            <label for="login_user_name">Email address</label>
            <div class="lg-input-wrap">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
                <input class="mb-input lg-input" type="text" name="user_name" id="login_user_name" autocomplete="username" spellcheck="false" v-model="Login_Request.user_name" />
            </div>
        </div>

        <div class="mb-field">
            <label for="login_password">Password</label>
            <div class="lg-input-wrap">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>
                <input class="mb-input lg-input" type="password" name="password" id="login_password" autocomplete="current-password" v-model="Login_Request.password" />
            </div>
        </div>

        <button type="button" class="button button-pink-book full lg-submit" :disabled="logging_in" @click="agent_login()">
            <svg v-if="logging_in" class="mb-spinner" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25" /><path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" /></svg>
            {{loginText()}}
        </button>
    </div>

    <div class="lg-links">
        <button type="button" class="lg-link" @click="Forgot_Password()">Forgot password?</button>
        <button v-if="!hide_new_agent_link()" type="button" class="lg-link" @click="Register()">New agent? Register here</button>
    </div>

    <p class="lg-contact">{{getContactInfo()}}</p>

</template>

<script lang="ts" src="./agent_login.ts"></script>
